import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBird = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.94705 0.596056L0.465617 4.0188L4.94689 7.5676M4.94705 0.596056L9.68293 7.56749M4.94705 0.596056L4.94689 7.5676M4.94673 14.5391L14.4074 14.5389L14.4191 0.595837L9.68293 7.56749M4.94673 14.5391L9.68293 7.56749M4.94673 14.5391L4.94689 7.5676",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgBird;
